import * as React from "react";
import * as days from "./style.module.scss";
export const Days = () => {
  return (
    <section className={days.days}>
      <div className="container">
        <ul>
          <li>
            <a href="#one">
              <h3>День 1</h3>
              <p>Возрастные изменения мозга: активное долголетие и тонус мозга</p>
            </a>
          </li>
          <li>
            <a href="#two">
              <h3>День 2</h3>
              <p>Способы вернуть энергию и тонус мозга</p>
            </a>
          </li>
          <li>
            <a href="#three">
              <h3>День 3</h3>
              <p>Как поддерживать тонус с пользой?</p>
            </a>
          </li>
          <li>
            <a href="#four">
              <h3>День 4</h3>
              <p>Как не бояться начинать новое и обрести веру в свои силы</p>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};
